import { render, staticRenderFns } from "./IndexTrend.vue?vue&type=template&id=65bbb712&scoped=true"
import script from "./IndexTrend.vue?vue&type=script&lang=js"
export * from "./IndexTrend.vue?vue&type=script&lang=js"
import style0 from "./IndexTrend.vue?vue&type=style&index=0&id=65bbb712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bbb712",
  null
  
)

export default component.exports